import React, { useCallback, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import { UsersContext } from '../../../contexts/UsersContext';
import userValidations from '../../../utils/userValidations';
import { PageContainer } from '../../../layouts';
import CreateUserForm from './CreateUserForm';


const initialValues = {
  email: '',
  password: '',
  confirmPassword: '',
  roles: [],
};

const CreateUser = ({ history }) => {
  const { actions, state } = useContext(UsersContext);

  useEffect(() => {
    if (!state.users.length) {
      actions.getUsers();
    }
  }, [actions, state.users.length]);

  const onSubmit = useCallback(
    async ({ email, password, roles }, formik) => {
      
      try {
       await actions.createUser({email, password, roles});
        history.push('/users');
      } catch (e) {
        //formik.setErrors(e);
        formik.setErrors({email: "Is already taken"});
      }
    },
    [actions, history]
  );

  return (
    <PageContainer component="main" maxWidth="sm">
      <Formik
        initialValues={initialValues}
        validationSchema={userValidations.createUser}
        onSubmit={onSubmit}
      >
        {(props) => <CreateUserForm {...props} />}
      </Formik>
    </PageContainer>
  );
};

export default withRouter(CreateUser);
